// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".column-container[data-v-0021cad7]{display:flex;flex-direction:column;align-items:center}.button[data-v-0021cad7]{width:40px;height:40px;margin-bottom:4px}", ""]);
// Exports
module.exports = exports;
